import React, {Component} from "react"
import Avatar from 'material-ui/Avatar'
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import classNames from 'classnames'
import Dialog from 'material-ui/Dialog'
import Person from 'material-ui/svg-icons/social/person'
import {Link} from 'react-router'
import SignUpField from '../Footer/SignUpField'
import syllabusConfig from "../../configs/syllabus-config"
import teamConfig from "../../configs/team-config"
import ElectricalIcon from '../../../public/images/icons/electrical.svg'
import EssentialsIcon from '../../../public/images/icons/essential.svg'
import MechanicalIcon from '../../../public/images/icons/mechanical.svg'
import SoftwareIcon from '../../../public/images/icons/software.svg'
const ElectricalImage = 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/materials/MM_Materials_Electrical.jpg?raw=true'
const EssentialImage = 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/materials/MM_Materials_Essential.jpg?raw=true'
const MechanicalImage = 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/materials/MM_Materials_Mechanical.jpg?raw=true'
const SoftwareImage = 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/materials/MM_Materials_Software.jpg?raw=true'


const _icons = {
  electrical: ElectricalIcon,
  essential: EssentialsIcon,
  mechanical: MechanicalIcon,
  software: SoftwareIcon
};

const images = {
  electrical: ElectricalImage,
  essential: EssentialImage,
  mechanical: MechanicalImage,
  software: SoftwareImage
}

class MaterialPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeName: null,
      dialogOpen: false,
    }

    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
  }

  handleOpen (name) {
    this.setState({activeName: name, dialogOpen: true})
  }

  handleClose () {
    this.setState({activeName: null, dialogOpen: false})
  }

  render () {
    const { params } = this.props
    const material = params.key
    const syllabus = syllabusConfig[material]
    const { activeName, dialogOpen } = this.state
    let activeTeamMate = {}

    teamConfig.forEach((teamMate)=> {
      if (teamMate.name === activeName) {
        activeTeamMate = teamMate
      }
    })

    const {description, role, type} = activeTeamMate

    const writerInfo = syllabus.writers.map(writer => {
      const { name, description, photo } = writer
      const syllabusAuthorClasses = classNames({
        "syllabus-author": true,
        "clickable": !!description
      })
      return (
        <div className={syllabusAuthorClasses} key={name} onClick={()=> this.handleOpen(name)}>
          {photo ? <Avatar size={40} src={photo} /> : <Person style={{width: '40px', height: '40px'}}/>}
          <div className="syllabus-author-text">
           <p>Author:</p>
            <div className="highlight-text"><p>{name}</p></div>
          </div>
        </div>
      )
    })

      const disciplineLeadInfo = syllabus.disciplineLead.map(dl => {
      const { name, description, photo } = dl
      const syllabusAuthorClasses = classNames({
        "syllabus-author": true,
        "clickable": !!description
      })
      return (
        <div className={syllabusAuthorClasses} key={name} onClick={()=>this.handleOpen(name)}>
          {photo ? <Avatar size={40} src={photo} /> : <Person style={{width: '40px', height: '40px'}}/>}
          <div className="syllabus-author-text">
            <p>Discipline Lead:</p>
            <div className="highlight-text"><p>{name}</p></div>
          </div>
        </div>
      )
    })

    const descriptions = syllabus.description.map((paragraph, index) => {
      return (
        <div className="syllabus-paragraphs" key={index}>
            <p>{paragraph}</p>
        </div>
      )
    })

    const appliedSkills = syllabus.appliedSkills.map((skill) => {
      return (
              <li key={skill}>{skill}</li>
      )
    })

    const conceptualSkills = syllabus.conceptualSkills.map((skill) => {
      return (
              <li key={skill}>{skill}</li>
      )
    })

    return (
      <div className="material-page">
        <div className="section-header">
          <Link to="/materials"><button className="back-button"><ChevronLeft color="#aa82ff"/><p>./Materials_</p></button></Link>
          <div className="title">
            <img src={_icons[material]} alt={material} className="material-icon"/>
            <h1>{syllabus.title}</h1>
          </div>
        </div>
        <hr className="hr-material"/>
        <div className="material-image-wrapper">
          <img src={images[material]} alt={material} className="material-image-header"/>
        </div>
        <div className="syllabus-grid">
          <div className="syllabus-media">
            <p>Sign up for updates and releases</p>
            <SignUpField
              label="Subscribe"
              message={`${material} subscription`}
              subject={material} />
          </div>
          <div className="syllabus-content">
            <div className="syllabus-author-by-line">
              {disciplineLeadInfo}
              {writerInfo}
            </div>
            {descriptions}
          </div>
        </div>
          <div className="material-skills">
            <div className="conceptual-skills">
              <h4>Conceptual Skills</h4>
              <ul>{conceptualSkills}</ul>
            </div>
            <div className="applied-skills">
              <h4>Applied Skills</h4>
              <ul>{appliedSkills}</ul>
            </div>
          </div>
          <Dialog
            autoScrollBodyContent={true}
            title={activeName}
            modal={false}
            contentStyle={{ width: '100%', maxWidth: 'none'}}
            open={dialogOpen && description}
            onRequestClose={this.handleClose}>
            { type && <p>{type}</p>}
            { role && <p>{role}</p>}
            <br />
            { description && <p className="dialog-description">{description}</p>}
          </Dialog>
      </div>
    )
  }
} 

export default MaterialPage



// WEBPACK FOOTER //
// ./src/components/Materials/Material.js